export const locale = {
  lang: 'en',
  data: {
    'EVENTCONFIRM': 'Confirmation',
    'EVENTYES': 'Yes',
    'EVENTCANCEL': 'Cancel'
  }
};
